function init() {
    InitContentTabs();
}
function InitContentTabs() {
	$(function () {
		$('#content-tab .content-tab--left-tabs ul li').each(function (i) {
			// set content on initial load
			if ($(this).hasClass('active')) {
				var tabContent = $(this).closest('#content-tab').find('.content-tab--right-content');
				$(tabContent).children('p').text($(this).data('content'));
				$(tabContent).find('.link-cta').attr('href', $(this).data('link'));
			}

			$(this).on('mouseenter focus', function (event) {
				$('#content-tab .content-tab--left-tabs ul li').removeClass('active')
				$(this).addClass('active');
				var tabContentElem = $(this).closest('#content-tab').find('.content-tab--right-content');
				$(tabContentElem).children('p').text($(this).data('content'));
				var bgImage = $(this).data('img');
				$(tabContentElem).children('div').children('a').text($(this).data('cta-text'));
				$('.content-tab--right-bg-img').css("background-image", "url(" + bgImage + ")");
				$(tabContentElem).find('.link-cta').attr('href', $(this).data('link'));
			})
		})

		// set content on initial load
		var selectBox = $('#content-tab .content-tab--left-selectBox select');
		var desktopListBox = $('#content-tab .content-tab--left-tabs');
		$(desktopListBox).find('li').each((index, el) => {
			$(el).attr('tabindex', 0);
		})
		var contentDefault = $(desktopListBox).find('.active').data('content');
		var imageDefault = $(desktopListBox).find('.active').data('img');
		var linkContentDefault = $(desktopListBox).find('.active').data('cta-text');
		var linkDefault = $(desktopListBox).find('.active').data('link');
		var tabContent = $('#content-tab').find('.content-tab--right-content');
		$('.content-tab--right-bg-img').css("background-image", "url(" + imageDefault + ")");
		$(tabContent).children('p').text(contentDefault);
		$(tabContent).children('div').children('a').text(linkContentDefault);
		$(tabContent).find('.link-cta').attr('href', linkDefault);

		$(selectBox).on('change', function () {
			var content = $(this).find(':selected').data('content');
			var link = $(this).find(':selected').data('link');
			var bgImage = $(this).find(':selected').data('img');
			var ctaText = $(this).find(':selected').data('cta-text');
			var tabContentElem = $(this).closest('#content-tab').find('.content-tab--right-content');
			$('.content-tab--right-bg-img').css("background-image", "url(" + bgImage + ")");
			$(tabContentElem).children('p').text(content);
			$(tabContentElem).children('div').children('a').text(ctaText);
			$(tabContentElem).find('.link-cta').attr('href', link);
		})
	})
}
export {
    init
}